<template>
  <div class="admin-reviews">
    <PageHeader>
      <div class="heading">
        <h1>
          <router-link :to="{name: 'admin-actions'}">Admin Actions</router-link>
          / <strong class="name">Product List Converter</strong>
        </h1>
      </div>
    </PageHeader>
    <div class="page-columns">
      <div class="col main">
        <div class="page-content admin-reviews">
          <div class="admin-reviews-form">
            <transition name="fade">
              <ProductListImportForm
                v-if="!jobCompleted"
                v-model="job"
                :companies="companies"
                :websites="websites"
                :pages="pages"
                @submit="startJob"
                :errors="errors"
              />
              <div v-else>
                <h2>
                  Adding all products! Please be patient and do not leave this
                  page.
                </h2>
                <router-link
                  :to="{
                    name: 'list',
                    params: {
                      companyId: job.companyId,
                      siteId: job.siteId,
                      pageId: job.pageId,
                      listId: createdListId
                    }
                  }"
                  class="btn is-primary"
                >
                  View Products
                </router-link>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="col side"></div>
    </div>
  </div>
</template>
<script>
import ProductListImportForm from '@/components/forms/ProductListImportForm'
import PageHeader from '@/components/PageHeader'

import page from '@/mixins/page'

import {readCompaniesData} from '@/lib/companies'
import {readCompanySitesData} from '@/lib/sites'
import {readCompanySitePagesData} from '@/lib/pages'

import {createCompanySitePageListData} from '@/lib/lists'
import {
  createCompanySitePageListListItemData,
  updateCompanySitePageListListItemData
} from '@/lib/list_items'
import {readListTypesData} from '@/lib/list_types'

export default {
  name: 'admin-product-list',

  mixins: [page],

  data() {
    return {
      jobCompleted: false,
      job: {},
      products: [
        {
          key: `Flower Crate - Birthday`,
          value: {
            product_title: `Flower Crate`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Flower Crate`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/dbb6d41d-df1a-42fa-842a-38d055e3d5c8/images/small.jpg?v=63782277901'
        },

        {
          key: `Birthday Girl - Birthday`,
          value: {
            product_title: `Birthday Girl`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Birthday Girl`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/5743f5ea-4ef6-4a34-a012-0cec0320cf55/images/small.jpg?v=63782277906'
        },

        {
          key: `Birthday Boy - Birthday`,
          value: {
            product_title: `Birthday Boy`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Birthday Boy`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/64308bbf-d173-406c-8563-d3b5af5b607c/images/small.jpg?v=63782277911'
        },

        {
          key: `Peacock - Birthday`,
          value: {
            product_title: `Peacock`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Peacock`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/bb318cd1-1e98-4e94-a1c0-b7f34ee70586/images/small.jpg?v=63782277921'
        },

        {
          key: `Bottles - Birthday`,
          value: {
            product_title: `Bottles`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Bottles`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/755dce7f-cba5-443a-bb40-108e4f41e584/images/small.jpg?v=63782277916'
        },

        {
          key: `Birthday Cake - Birthday`,
          value: {
            product_title: `Birthday Cake`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Birthday Cake`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/3b9d6859-00c6-4c1c-b06d-b783e93f41ac/images/small.jpg?v=63782277926'
        },

        {
          key: `Cupcakes - Birthday`,
          value: {
            product_title: `Cupcakes`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Cupcakes`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/9aac7c3a-8563-4835-a9e8-f10d2cf4b3a3/images/small.png?v=63782277937'
        },

        {
          key: `Balloons - Birthday`,
          value: {
            product_title: `Balloons`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Balloons`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/3db5afca-e01f-44cb-93f0-b4a0ffd54bbd/images/small.jpg?v=63782442102'
        },

        {
          key: `Candles - Birthday`,
          value: {
            product_title: `Candles`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Candles`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/b2f2bb64-d6d3-4b29-8504-3be028724f74/images/small.jpg?v=63782277941'
        },

        {
          key: `Flamingo & Ferns - Birthday`,
          value: {
            product_title: `Flamingo & Ferns`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Flamingo & Ferns`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/db0d00ea-b2be-4970-838c-864a8ba5f6ac/images/small?v=63782277947"'
        },

        {
          key: `Hello Gorgeous - Birthday`,
          value: {
            product_title: `Hello Gorgeous`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Hello Gorgeous`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/c0b29eb6-ff98-43f4-b71d-525a391d3647/images/small.jpg?v=63782277950'
        },

        {
          key: `Happy Birthday - Birthday`,
          value: {
            product_title: `Happy Birthday`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Happy Birthday`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/747543e6-aa9a-45ac-b536-1b69349a18d9/images/small.jpg?v=63782277956'
        },

        {
          key: `Cupcake - Birthday`,
          value: {
            product_title: `Cupcake`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Cupcake`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/b23d71e6-5ec6-4370-abc1-c7474c502286/images/small.jpg?v=63782277961'
        },

        {
          key: `Fanned Peacock - Birthday`,
          value: {
            product_title: `Fanned Peacock`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Fanned Peacock`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/cb8a5b6b-43a3-465a-8801-670a19c07b5d/images/small.jpg?v=63782277966'
        },

        {
          key: `Wild Flowers – Best wishes - Birthday`,
          value: {
            product_title: `Wild Flowers – Best wishes`,
            product_category: 'Birthday',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Wild Flowers – Best wishes`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/129681d7-4e87-4c2f-97e4-9cb6e625d226/images/small.jpg?v=63782277971'
        },

        {
          key: `Birthday boy - Kids`,
          value: {
            product_title: `Birthday boy`,
            product_category: 'Kids',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Birthday boy`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/54de49d2-816d-486d-b3d0-4b424166b258/images/small.jpg?v=63782277975'
        },

        {
          key: `Dino the Dinosaur - Kids`,
          value: {
            product_title: `Dino the Dinosaur`,
            product_category: 'Kids',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Dino the Dinosaur`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/7179d610-3f94-4239-8f29-69b63db231bc/images/small.jpg?v=63782277981'
        },

        {
          key: `Ollie the Octopus - Kids`,
          value: {
            product_title: `Ollie the Octopus`,
            product_category: 'Kids',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Ollie the Octopus`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/7860c5c1-d4d2-4a4b-a51f-8602fe02c9c8/images/small.jpg?v=63782442532'
        },

        {
          key: `Olivia the Owl - Kids`,
          value: {
            product_title: `Olivia the Owl`,
            product_category: 'Kids',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Olivia the Owl`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/c97733f4-35d7-49fd-a1c2-3bd1b67e6bf5/images/small.jpg?v=63782277991'
        },

        {
          key: `Leo the Lion - Kids`,
          value: {
            product_title: `Leo the Lion`,
            product_category: 'Kids',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Leo the Lion`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/7d4f6e71-6e04-4709-a002-4f5cff681ad0/images/small.jpg?v=63782277996'
        },

        {
          key: `Alphabet (Individual letters) - Kids`,
          value: {
            product_title: `Alphabet (Individual letters)`,
            product_category: 'Kids',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Alphabet (Individual letters)`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/a17cfc02-e44a-4b61-8e27-a00f57b1be59/images/small.jpg?v=63782278000'
        },

        {
          key: `Tulip - Monochrome`,
          value: {
            product_title: `Tulip`,
            product_category: 'Monochrome',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Tulip`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/3148ed2f-57eb-4c94-8bc7-ae80a5238bd4/images/small.jpg?v=63782442836'
        },

        {
          key: `Sunflower - Monochrome`,
          value: {
            product_title: `Sunflower`,
            product_category: 'Monochrome',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Sunflower`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/51753a2e-c0d2-4b72-af8f-4a5d87da80b8/images/small.jpg?v=63782442775'
        },

        {
          key: `Cocktails - Monochrome`,
          value: {
            product_title: `Cocktails`,
            product_category: 'Monochrome',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Cocktails`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/d66427b7-c976-4fa3-8b0b-73306219a6f4/images/small.jpg?v=63782278141'
        },

        {
          key: `Heart - Monochrome`,
          value: {
            product_title: `Heart`,
            product_category: 'Monochrome',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Heart`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/67682a60-bc19-477f-8ac2-7989fb1e27b1/images/small.jpg?v=63782442816'
        },

        {
          key: `Shoes - Just For You`,
          value: {
            product_title: `Shoes`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Shoes`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/dedaf55b-5ae8-44be-9c62-4ed7283973fb/images/small.jpg?v=63782442988'
        },

        {
          key: `Rainbow - Just For You`,
          value: {
            product_title: `Rainbow`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Rainbow`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/3f0a64c4-f94b-4a74-8210-621a860d70b0/images/small.jpg?v=63782442376'
        },

        {
          key: `Flowers in Teapot - Just For You`,
          value: {
            product_title: `Flowers in Teapot`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Flowers in Teapot`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/00c902ee-52e5-46b5-b649-c70a2786b75e/images/small.jpg?v=63782442404'
        },

        {
          key: `Shoes on box - Just For You`,
          value: {
            product_title: `Shoes on box`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Shoes on box`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/11c01f6e-36ee-4b35-b8f5-9ad5461a69b9/images/small.jpg?v=63782442944'
        },

        {
          key: `Fairy - Just For You`,
          value: {
            product_title: `Fairy`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Fairy`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/64564bd5-3073-46fc-903e-80fee61515b8/images/small.jpg?v=63782442264'
        },

        {
          key: `Flamingo - Just For You`,
          value: {
            product_title: `Flamingo`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Flamingo`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/d93cb9df-09c9-4bce-9eb5-c217d3984593/images/small.png?v=63782442056'
        },

        {
          key: `Pansies - Just For You`,
          value: {
            product_title: `Pansies`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Pansies`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/ab71d7f4-6920-4760-811e-7b0fb8965804/images/small.jpg?v=63782278040'
        },

        {
          key: `Weeping Tree - Just For You`,
          value: {
            product_title: `Weeping Tree`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Weeping Tree`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/f374cf90-3081-42b2-b640-e08845d4b26a/images/small.jpg?v=63782278045'
        },

        {
          key: `Painted Trees - Just For You`,
          value: {
            product_title: `Painted Trees`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Painted Trees`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/e967ee69-9f6c-49bf-9328-35a15151cbef/images/small.jpg?v=63782278049'
        },

        {
          key: `Busy Bees - Just For You`,
          value: {
            product_title: `Busy Bees`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Busy Bees`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/b3af1f12-23f1-44fb-860c-da10d9be3693/images/small.jpg?v=63782278053'
        },

        {
          key: `Sunflower - Just For You`,
          value: {
            product_title: `Sunflower`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Sunflower`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/ac63a32a-3f9c-46cf-9eb3-2ec016bc0b4c/images/small.jpg?v=63782278058'
        },

        {
          key: `Cocktails - Just For You`,
          value: {
            product_title: `Cocktails`,
            product_category: 'Just For You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Cocktails`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/d66427b7-c976-4fa3-8b0b-73306219a6f4/images/small.jpg?v=63782278141'
        },

        {
          key: `Heart of Hope - Hearts`,
          value: {
            product_title: `Heart of Hope`,
            product_category: 'Hearts',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Heart of Hope`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/b37c3d54-cdf8-47c1-9b0c-93d0a0640852/images/small.jpg?v=63782442670'
        },

        {
          key: `With Love - Heart`,
          value: {
            product_title: `With Love`,
            product_category: 'Hearts',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `With Love`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/607ccb6b-83c7-42f5-8c5e-15d1e9c8b704/images/small.jpg?v=63782278087'
        },

        {
          key: `Mauve Heart - Heart`,
          value: {
            product_title: `Mauve Heart`,
            product_category: 'Hearts',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Mauve Heart`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/bdad9cad-ec6b-4ed4-bdc9-cc38e7e206cb/images/small.jpg?v=63782278091'
        },

        {
          key: `Heart of Hearts - Hearts`,
          value: {
            product_title: `Heart of Hearts`,
            product_category: 'Hearts',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Heart of Hearts`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/04006ca3-3b93-42b1-a735-f4a66787ba8c/images/small.jpg?v=63782278096'
        },

        {
          key: `Pink & Mauve Heartsterned Heart - Hearts`,
          value: {
            product_title: `Pink & Mauve Patterned Heart`,
            product_category: 'Hearts',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Pink & Mauve Patterned Heart`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/5aa63384-1c49-43ed-a1d7-5f0481f7a97a/images/small.jpg?v=63782278101'
        },

        {
          key: `Pink Heart - Hearts`,
          value: {
            product_title: `Pink Heart`,
            product_category: 'Hearts',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Pink Heart`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/50446c7d-24f5-43cf-9207-6732e684ffda/images/small.jpg?v=63782278106'
        },

        {
          key: `Fluorescent Heart - Hearts`,
          value: {
            product_title: `Fluorescent Heart`,
            product_category: 'Hearts',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Fluorescent Heart`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/85b31e6d-27ce-469a-9088-18c7a6be88c8/images/small.jpg?v=63782278111'
        },

        {
          key: `Silver Heart - Hearts`,
          value: {
            product_title: `Silver Heart`,
            product_category: 'Hearts',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Silver Heart`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/32dd27c1-46c9-4bf5-ac06-9ddd7d42dd80/images/small.jpg?v=63782278117'
        },

        {
          key: `Floral Heart - Hearts`,
          value: {
            product_title: `Floral Heart`,
            product_category: 'Hearts',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Floral Heart`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/5841aea8-7dab-4958-b795-0a288765315d/images/small.jpg?v=63782278122'
        },

        {
          key: `You’ve Moved - New Home`,
          value: {
            product_title: `You’ve Moved`,
            product_category: 'New Home',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `You’ve Moved`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/2a5b2709-67a8-4446-b6a7-6205d1f7bdcd/images/small?v=63782278153"'
        },

        {
          key: `3 Homes - New Home`,
          value: {
            product_title: `3 Homes`,
            product_category: 'New Home',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `3 Homes`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/b5c79ab0-b861-496b-b041-da6480b3fcb7/images/small?v=63782278157"'
        },

        {
          key: `Good Luck - Good Luck`,
          value: {
            product_title: `Good Luck`,
            product_category: 'Good Luck',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Good Luck`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/4fa5fc74-8a79-4f7a-97f4-c7361f2c74b2/images/small.jpg?v=63782441982'
        },

        {
          key: `Thank you - Thank You`,
          value: {
            product_title: `Thank you`,
            product_category: 'Thank You',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Thank you`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/ac76925b-5fec-49aa-9889-e710d16bbd6e/images/small.jpg?v=63782442442'
        },

        {
          key: `Happy Easter - Easter`,
          value: {
            product_title: `Happy Easter`,
            product_category: 'Easter',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Happy Easter`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/1f21bff1-dd5a-4466-a775-1242616b9e97/images/small.png?v=63782351011'
        },

        {
          key: `Easter Wishes - Easter`,
          value: {
            product_title: `Easter Wishes`,
            product_category: 'Easter',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Easter Wishes`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/81e77f68-3556-43f4-b631-178152592438/images/small.png?v=63782351061'
        },

        {
          key: `Thinking of you this Easter - Easter`,
          value: {
            product_title: `Thinking of you this Easter`,
            product_category: 'Easter',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Thinking of you this Easter`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/56aa79a5-619d-4e6b-9ac2-68027f4ac1f6/images/small.png?v=63782278204'
        },

        {
          key: `Entwined Hearts - Anniversary`,
          value: {
            product_title: `Entwined Hearts`,
            product_category: 'Anniversary',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Entwined Hearts`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/22e5f8bc-6a98-4d1a-8a1c-907e7487fcdf/images/small.jpg?v=63782278067'
        },

        {
          key: `4 Hearts - Anniversary`,
          value: {
            product_title: `4 Hearts`,
            product_category: 'Anniversary',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `4 Hearts`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/41f9af55-e5a0-4db8-843c-13693b6ac2a0/images/small.jpg?v=63782278072'
        },

        {
          key: `Wedding Cake - Anniversary`,
          value: {
            product_title: `Wedding Cake`,
            product_category: 'Anniversary',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Wedding Cake`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/44802290-54fd-4eb4-bd24-80f7b5c39c2e/images/small.jpg?v=63782278077'
        },

        {
          key: `Happy Wedding Day - Anniversary`,
          value: {
            product_title: `Happy Wedding Day`,
            product_category: 'Anniversary',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Happy Wedding Day`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/ce76d0e9-8aba-40fc-8e39-e8b1f008a693/images/small.jpg?v=63782278081'
        },

        {
          key: `Two snowmen - Christmas`,
          value: {
            product_title: `Two snowmen`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Two snowmen`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/42059403-f3e9-463d-9372-a59a6547e7c0/images/small?v=63782278213"'
        },

        {
          key: `Stocking - Christmas`,
          value: {
            product_title: `Stocking`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Stocking`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/e0f20935-8196-47f6-886b-a6518433385f/images/small?v=63782278200"'
        },

        {
          key: `Christmas Heart - Christmasx`,
          value: {
            product_title: `Christmas Heart`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Christmas Heart`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/3452ca00-a72d-42b3-92a4-c2380c0d413e/images/small.jpg?v=63782351358'
        },

        {
          key: `Silver Tree - Christmas`,
          value: {
            product_title: `Silver Tree`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Silver Tree`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/5fa437a6-0b4a-4187-a972-977fff1773fb/images/small?v=63782351273"'
        },

        {
          key: `Two Hearts - Christmas`,
          value: {
            product_title: `Two Hearts`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Two Hearts`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/8c89fbab-f363-4965-a283-1231a07e4bda/images/small?v=63782278249"'
        },

        {
          key: `Snowman family - Christmas`,
          value: {
            product_title: `Snowman family`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Snowman family`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/3df8b038-24d3-4f2c-8598-b8add6297b8a/images/small?v=63782278217"'
        },

        {
          key: `Wreath - Christmas`,
          value: {
            product_title: `Wreath`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Wreath`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/3000692a-b2d0-42cf-b163-3296c7c708fd/images/small?v=63782278225"'
        },

        {
          key: `Holly Star - Christmas`,
          value: {
            product_title: `Holly Star`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Holly Star`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/d1aba4d2-fe6b-4e74-bf52-1bd32d60cac6/images/small?v=63782278229"'
        },

        {
          key: `Reindeer - Christmas`,
          value: {
            product_title: `Reindeer`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Reindeer`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/3ae6d065-67bb-4809-887a-4b489b8fb077/images/small?v=63782278237"'
        },

        {
          key: `Christmas Bay - Christmas`,
          value: {
            product_title: `Christmas Bay`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Christmas Bay`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/066a167e-f476-4d81-bd93-3fa111c5228d/images/small?v=63782278242"'
        },

        {
          key: `Merry Christmas - Christmasx`,
          value: {
            product_title: `Merry Christmas`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Merry Christmas`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/aa83f583-883b-456f-8f3a-cbeed5b4e029/images/small?v=63782278247"'
        },

        {
          key: `Snowman - Christmas`,
          value: {
            product_title: `Snowman`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Snowman`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/e715c9a7-9df0-4cee-a8c5-4a90e581a21a/images/small?v=63782278251"'
        },

        {
          key: `Christmas Rose - Christmas`,
          value: {
            product_title: `Christmas Rose`,
            product_category: 'Christmas',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Christmas Rose`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/88c62632-7dba-490f-861a-36d2381d8011/images/small.jpg?v=63782278254'
        },

        {
          key: `Sorry You’re Leaving - Leaving`,
          value: {
            product_title: `Sorry You’re Leaving`,
            product_category: 'Leaving',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Sorry You’re Leaving`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/1b15d82c-b6d4-4537-acc0-123656c685d4/images/small.jpg?v=63782278257'
        },

        {
          key: `Baby Boy - New Baby`,
          value: {
            product_title: `Baby Boy`,
            product_category: 'New Baby',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Baby Boy`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/b5d9f153-3ade-41aa-b73c-184a711c5aa4/images/small.jpg?v=63782442512'
        },

        {
          key: `Boy Teddy and Balloons - New Baby`,
          value: {
            product_title: `Boy Teddy and Balloons`,
            product_category: 'New Baby',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Boy Teddy and Balloons`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/b2eb49ea-f8dc-4fa3-a370-9052ff41991e/images/small.jpg?v=63782278270'
        },

        {
          key: `Baby Girl - New Baby`,
          value: {
            product_title: `Baby Girl`,
            product_category: 'New Baby',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Baby Girl`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/c353c63d-5bcf-46d0-8034-45dad3461781/images/small.jpg?v=63782442471'
        },

        {
          key: `Wonderful News - New Baby`,
          value: {
            product_title: `Wonderful News`,
            product_category: 'New Baby',
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Wonderful News`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/dbd59359-0b98-450f-93a7-754fb056d3bf/images/small.jpg?v=63782278279'
        },

        {
          key: `Wildflowers - Mothers Day`,
          value: {
            product_title: `Wildflowers`,
            product_category: `Mother's Day`,
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Wildflowers`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/87638b68-04cf-4029-b740-79002b28c9cf/images/small.jpg?v=63782277877'
        },

        {
          key: `Love you Mum heart - Mothers Day`,
          value: {
            product_title: `Love you Mum heart`,
            product_category: `Mother's Day`,
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Love you Mum heart`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/8d9ae50d-f9b0-4036-92a9-d97784cc5cc1/images/small.png?v=63782277892'
        },

        {
          key: `With love on Mother’s Day - Mothers Day`,
          value: {
            product_title: `With love on Mother’s Day`,
            product_category: `Mother's Day`,
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `With love on Mother’s Day`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/58f8484a-be5c-459f-a663-3851401321d7/images/small.jpg?v=63782277886'
        },

        {
          key: `With Love Mum on Mothers Day - Mothers Day`,
          value: {
            product_title: `With Love Mum on Mothers Day`,
            product_category: `Mother's Day`,
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `With Love Mum on Mothers Day`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/2d4da8db-ff13-49b5-8b6e-a85964ea4b56/images/small.jpg?v=63782277892'
        },

        {
          key: `Mother's Day - Mothers Day`,
          value: {
            product_title: `Mother's Day`,
            product_category: `Mother's Day`,
            product_currency: '£',
            product_price: '3',
            text_position: 'text-right',
            text_width: 'two-thirds',
            text_alignment: 'align-middle',
            boxed: true,
            bottom_spacing: true,
            image_alt_text: `Mother's Day`
          },
          image_url: 'https://page-maker-pro-uploads-prod.s3.amazonaws.com/lists/7a5da751-6c64-42f7-a23c-94abb28eb095/list_items/6bf3fb7c-08d3-4a79-a2bd-1571c11e853f/images/small.jpg?v=63782277896'
        }
      ],
      errors: {},
      logs: ['Ready...'],
      title: 'Product importer',
      companies: [],
      websites: [],
      pages: [],
      createdListId: '',
      page: {page: 1, page_size: 500}
    }
  },

  components: {
    ProductListImportForm,
    PageHeader
  },

  computed: {
    productList() {
      return this.listTypes.find((type) => type.name === 'product-list')
    }
  },

  methods: {
    getData() {
      readListTypesData().then(({data}) => {
        this.listTypes = data
      })

      readCompaniesData(this.page).then(({data}) => {
        data.forEach((company) => {
          this.companies.push({
            key: company.name,
            value: company.id
          })
        })
      })
    },

    getCompanySites() {
      readCompanySitesData(this.job.companyId, this.page).then(({data}) => {
        this.websites = []

        data.forEach((site) => {
          this.websites.push({
            key: site.name,
            value: site.id
          })
        })
      })
    },

    getCompanySitePages() {
      readCompanySitePagesData(
        this.job.companyId,
        this.job.siteId,
        this.page
      ).then(({data}) => {
        this.pages = []

        data.forEach((page) => {
          this.pages.push({
            key: page.name,
            value: page.id
          })
        })
      })
    },

    startJob() {
      this.createPageProducts()
    },

    createPageProducts() {
      let list = {
        name: 'Product List',
        list_type_id: this.productList.id,
        weight: 10
      }

      createCompanySitePageListData(
        this.job.companyId,
        this.job.siteId,
        this.job.pageId,
        list
      )
        .then(({data}) => {
          let createdList = data
          let products = this.products
          let listItem
          this.createdListId = data.id

          this.logs.push(`Successfully created '${createdList.name}'`)

          for (let i = 0; i < products.length; i++) {
            let content = products[i]

            listItem = {
              key: content.key,
              value: `${JSON.stringify(content.value)}`,
              weight: i
            }

            this.createPageListListItem(createdList, listItem, i)
          }

          this.completeJob()
        })
        .catch(({response}) => {
          this.logs.push(response)
        })
    },

    createPageListListItem(createdList, listItem, index) {
      createCompanySitePageListListItemData(
        this.job.companyId,
        this.job.siteId,
        this.job.pageId,
        createdList.id,
        listItem
      )
        .then(({data}) => {
          let listItem = data
          this.logs.push(`Successfully created list item ${listItem.key}`)

          this.uploadImageToItem(createdList.id, listItem.id, index)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    uploadImageToItem(listId, listItemId, index) {
      window.setTimeout(() => {
        updateCompanySitePageListListItemData(
          this.job.companyId,
          this.job.siteId,
          this.job.pageId,
          listId,
          listItemId,
          {image: this.products[index].image_url}
        ).then(({data}) => {
        })
      }, index * 5000)
    },

    completeJob() {
      this.jobCompleted = true
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    'job.companyId'() {
      this.getCompanySites()
    },

    'job.siteId'() {
      this.getCompanySitePages()
    }
  }
}
</script>
<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'

</style>
